import { useTranslation } from 'react-i18next';
import { MARKETS } from '../constants';

const useMarketOptions = () => {
  const { t } = useTranslation('scout');

  const formattedMarkets = Object.values(MARKETS).map((market) => ({ label: market.toUpperCase(), value: market }));

  return [...formattedMarkets, { label: t('other'), value: 'Other' }];
};

export default useMarketOptions;
